import { MasterPlanLocationFilter } from "./master-plan-location-filter";


export class LocationGroupFilterForPlanContainer {
    id!: string;
    name!: string;
    source!: string;
    planContainerId!: string;
    filters!: MasterPlanLocationFilter[];
}